import React from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../components/PageMeta';

// WO-42: unknown paths (nginx serves them with status 404, so crawlers see a real 404 instead of a soft 404).
export default function NotFoundPage() {
  return (
    <div className="text-cream py-16 text-center">
      <PageMeta title="Page not found | Lilycove" />
      <h1 className="text-3xl font-bold mb-3">Page not found</h1>
      <p className="text-cream/70 mb-6">This page does not exist. Try a search, or browse sets and Canadian stores.</p>
      <div className="flex justify-center gap-6">
        <Link to="/series" className="underline">Browse sets</Link>
        <Link to="/stores" className="underline">Canadian stores</Link>
        <Link to="/" className="underline">Home</Link>
      </div>
    </div>
  );
}
